<template>
  <div class="position-relative" :class="wrapperClass">
    <iframe
      ref="iframeRef"
      class="w-100 h-100 position-absolute left-0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      :src="url"
      width="auto"
      height="auto"
      frameborder="0"
      allowfullscreen
    >
    </iframe>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'

export default {
  name: 'VideoIframe',
  props: {
    url: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '16-9'
    }
  },
  emits: ['click-iframe', 'loaded'],
  setup (props, { emit }) {
    const wrapperClass = computed(() => `video-iframe-${props.size}`)
    const iframeRef = ref(null)

    onMounted(() => {
      const listener = () => {
        if (document.activeElement === iframeRef.value) {
          emit('click-iframe')
        }

        window.removeEventListener('blur', listener)
      }

      window.addEventListener('blur', listener)

      iframeRef.value.addEventListener('load', () => {
        emit('loaded')
      })
    })

    return {
      wrapperClass,
      iframeRef
    }
  }
}
</script>

<style scoped>
.video-iframe-16-9 {
  height: 0;
  padding-bottom: 56.25%
}
.video-iframe-3-2 {
  height: 0;
  padding-bottom: 66.66%
}
.video-iframe-4-3 {
  height: 0;
  padding-bottom: 75%
}
.video-iframe-1-1 {
  height: 0;
  padding-bottom: 100%
}
</style>
